import { render } from "./DispatcherEditModal.vue?vue&type=template&id=56919790&scoped=true"
import script from "./DispatcherEditModal.vue?vue&type=script&lang=js"
export * from "./DispatcherEditModal.vue?vue&type=script&lang=js"

import "./DispatcherEditModal.vue?vue&type=style&index=0&id=56919790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56919790"]])

export default __exports__